module.exports = __webpack_public_path__ + "media/factory.dc679da5.mp4";